import { defineAsyncComponent, type Component } from 'vue'

export interface GetStartedSettingsContributionRegistrar {
  (contribution: { key: string; component: Component }): void
}

const component = defineAsyncComponent(
  () => import('./components/basics/GetStartedWorkspaceSettings.vue'),
)

/** App-composed adapter: module 22 contributes without importing module 29. */
export function installGetStartedWorkspaceSettings(
  register: GetStartedSettingsContributionRegistrar,
): void {
  register({ key: 'workspace-basics', component })
}
